<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">
        Crear orden de servicio /
        <router-link to="/ordenes">
          <a href="#">Regresar a ordenes de servicio</a>
        </router-link>
      </div>
      <div class="panel-body">
        <div class="col-md-6">
          <div class="form-group">
            <md-autocomplete v-model="cliente" :md-options="clientes">
              <label>Buscar cliente</label>
              <template
                slot="md-autocomplete-item"
                slot-scope="{ item }"
              >
                {{
                  `${item.cedula} _ ${item.nombre} ${
                    item.apellidos
                  } _ ${item.celular}`
                }}
              </template>
              <template slot="md-autocomplete-empty"
                >No se encontrarón datos</template
              >
            </md-autocomplete>
            <!-- <vue-bootstrap-typeahead
              style="display: grid;"
              inputClass="col-md-12 form-control"
              :data="clientes"
              v-model="cliente"
              size="lg"
              :serializer="
                item => {
                  return `${item.cedula} _ ${item.nombre} ${item.apellidos} _ ${item.celular}`;
                }
              "
              placeholder="Selecciona el cliente"
            />-->
            <!-- <autocomplete
              ref="autocomplete"
              placeholder="Selecciona el cliente"
              :source="clientes"
              input-class="form-control"
              results-property="clientes"
              :results-display="
                item => {
                  return `${item.cedula} _ ${item.nombre} ${item.apellidos}`;
                }
              "
              @selected="item => {}"
            >
            </autocomplete>-->
          </div>
          <div class="form-group">
            <label>Síntoma</label>
            <textarea
              autocomplete="on"
              v-model="sintoma"
              name="user"
              class="form-control"
              rows="3"
            ></textarea>
            <!-- <input
              type="text"
              name="email"
              placeholder="Ingrese el síntoma"
              class="form-control"
              v-model="sintoma"
            />-->
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-md-6">
                <label>Seleccione Marca</label>
                <select class="form-control" v-model="marca">
                  <option value="OTRA">OTRA</option>
                  <option
                    v-for="(option, index) in marcas"
                    :key="index"
                    v-bind:value="option.id"
                    >{{ option.marca }}</option
                  >
                </select>
              </div>
              <div class="col-md-6">
                <label>Seleccione Equipo</label>
                <select class="form-control" v-model="diagnostico">
                  <option
                    v-for="(e, i) in equipos"
                    v-bind:value="e.referencia"
                    >{{ e.referencia }}</option
                  >
                </select>
              </div>
            </div>
            <div class="form-group" v-if="diagnostico === 'Otro'">
              <label>Otro</label>
              <input
                autocomplete="on"
                class="form-control"
                type="text"
                name="email"
                v-model="otroDiagnostico"
                placeholder="Ingrese el nombre del equipo"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div
                :class="
                  estado.estado === 'Pendiente'
                    ? 'col-md-4'
                    : 'col-md-6'
                "
              >
                <label>Seleccione Estado</label>
                <select
                  class="form-control"
                  v-model="estado.estado"
                  @change="reasignarEstado"
                >
                  <option value="Aprobado">Aprobado</option>
                  <option value="Urgente">Urgente</option>
                  <option value="Pendiente">Pendiente</option>
                  <option value="No autorizado">No autorizado</option>
                </select>
              </div>
              <div
                class="col-md-4"
                v-if="estado.estado === 'Pendiente'"
              >
                <label>¿Qué está pendiente?</label>
                <md-checkbox
                  @change="validarCheckboxEstado('autorizacion')"
                  v-model="estado.pendiente.autorizacion"
                  class="md-primary"
                  >Autorización</md-checkbox
                >
                <md-checkbox
                  @change="validarCheckboxEstado('repuesto')"
                  v-model="estado.pendiente.repuesto"
                  class="md-primary"
                  >Repuesto</md-checkbox
                >
                <md-checkbox
                  @change="validarCheckboxEstado('cotizacion')"
                  v-model="estado.pendiente.cotizacion"
                  class="md-primary"
                  >Cotización</md-checkbox
                >
              </div>
              <div
                :class="
                  estado.estado === 'Pendiente'
                    ? 'col-md-4'
                    : 'col-md-6'
                "
              >
                <label>Seleccione Servicio</label>
                <select class="form-control" v-model="servicio">
                  <option value="NINGUNO">NINGUNO</option>
                  <option value="revision_mostrador"
                    >Revisión mostrador</option
                  >
                  <option value="Ajuste">Ajuste</option>
                  <option value="Garantia">Garantía</option>
                  <option value="Revision">Revisión</option>
                  <option value="Venta">Venta</option>
                  <option value="Mantenimiento">Mantenimiento</option>
                  <option value="Reparacion">Reparación</option>
                  <option value="No_tiene"
                    >Nó tiene reparación</option
                  >
                  <option value="Analisis">Análisis</option>
                </select>
              </div>
            </div>
          </div>
          <div
            class="form-group"
            v-if="
              estado.estado === 'Urgente' ||
                servicio === 'Analisis' ||
                servicio === 'revision_mostrador'
            "
          >
            <md-autocomplete
              v-model="tecnico"
              :md-options="tecnicosSelect"
              md-dense
            >
              <label>Asignar técnico</label>
            </md-autocomplete>
          </div>
          <div class="form-group">
            <label>Accesorios</label>
            <textarea
              autocomplete="on"
              name="accesorios"
              v-model="accesorios"
              class="form-control"
              rows="4"
            ></textarea>
            <!-- <input
              v-model="accesorios"
              class="form-control"
              type="text"
              placeholder="Ingrese los accesorios"
            />-->
          </div>
          <div class="form-group">
            <label>Precio</label>
            <money
              v-model="precio"
              class="form-control"
              :precision="0"
            ></money>
          </div>
          <div class="form-group">
            <label>OBSERVACIONES INTERNAS</label>
            <textarea
              autocomplete="on"
              name="observaciones"
              v-model="observaciones"
              class="form-control"
              rows="3"
            ></textarea>
            <!-- <input
              v-model="observaciones"
              name="email"
              type="text"
              placeholder="Ingrese las observaciones internas"
              class="form-control"
            />-->
          </div>

          <button
            @click="checkForm"
            style="width: 100%;"
            class="btn btn-primary"
            :disabled="disabledButton"
          >
            Guardar
          </button>
        </div>
      </div>

      <div hidden class="col-md-6" id="impresion">
        <div
          class="texto"
          style="margin: auto;padding: 15px;border: 0;background: white;max-width: 700px;width: 90%;color: #82899A;"
        >
          <table width="100%" style="margin: 0;padding: 0;border: 0;">
            <tr style="margin: 0;padding: 0;border: 0;">
              <td style="margin: 0;padding: 0;border: 0;">
                <h1>SOLUCASA</h1>
              </td>
            </tr>
            <tr style="margin: 0;padding: 0;border: 0;">
              <td style="margin: 0;padding: 0;border: 0;">
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>Régimen no responsable de IVA.</b>
                </p>
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>NIT. 42.775.833-7</b>
                </p>
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>Cra 53 # 61-15, Medellín</b>
                </p>
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>Tel. 604 4734651 - Móvil 324 454 0402</b>
                </p>
                <br />
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>Fecha: {{ getFecha() }}</b>
                </p>
                <br />
                <h4
                  style="margin: 0;padding: 0;border: 0; font-size: 22px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>{{ `${cliente.split('_')[1]}` }}</b>
                </h4>
                <h5
                  style="margin: 0;padding: 0;border: 0; font-size: 20px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>
                    <p id="orden_id"></p>
                  </b>
                </h5>
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>Síntoma:</b>
                  {{ sintoma }}
                </p>
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>Marca:</b>
                  {{
                    marcas.length > 0
                      ? marcas.filter(m => m.id === marca)[0].marca
                      : ''
                  }}
                </p>
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>Equipo: </b>{{ diagnostico }}
                </p>
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>Estado:</b>
                  {{ estado.estado }}
                </p>
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>Servicio:</b>
                  {{ servicio }}
                </p>
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>Accesorios:</b>
                  {{ accesorios }}
                </p>
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  v-if="precio || precio > 0"
                >
                  <b>Precio:</b>
                  {{ precio | currency }}
                </p>
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  v-if="
                    servicio === 'Venta' || servicio === 'Garantia'
                  "
                ></p>
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>Garantía:</b>
                  {{
                    servicio === 'Venta'
                      ? '1 Mes'
                      : servicio === 'Reparacion'
                      ? '1 Mes'
                      : ''
                  }}
                </p>
                <p
                  style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                >
                  <b>Nota:</b> Si pasados 3 meses su producto no ha
                  sido retirado, solucasa dispondrá de este. (Ley 1480
                  de 2011). Las garantías se cubren de acuerdo al daño
                  reparado.
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<script>
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
import { Money } from 'v-money';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { mapState } from 'vuex';
import Moment from 'moment';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import Autocomplete from 'vuejs-auto-complete';
export default {
  name: 'crear-orden',
  components: {
    Loading,
    Money,
    VueBootstrapTypeahead,
    Autocomplete,
  },
  computed: mapState(['topicSocket', 'usuarioId']),
  props: {
    clienteId: Object,
  },
  data() {
    return {
      loading: true,
      disabledButton: false,
      otroDiagnostico: '',
      clientes: [],
      clientesList: [],
      cliente: '',
      sintoma: '',
      marca: 100,
      marcas: [],
      equipos: [],
      diagnostico: 'NINGUNO',
      estado: {
        estado: 'Aprobado',
        pendiente: {
          autorizacion: false,
          repuesto: false,
          cotizacion: false,
        },
      },
      observaciones: '',
      servicio: 'NINGUNO',
      accesorios: '',
      precio: 0,
      tecnicos: [],
      tecnicosSelect: [],
      tecnico: '',
      ordenId: 0,
    };
  },
  watch: {
    marca() {
      if (this.marca === 'OTRA') {
        this.showModalCreateMarca();
      }
    },
    cliente() {
      if (this.cliente.length > 0) {
        this.getClientes();
      } else {
        this.clientesList = [];
      }
    },
  },
  computed: {},
  created() {
    let cliente = this.$router.history.current.params.clienteId;
    if (cliente) {
      this.cliente = `${cliente.cedula}_${cliente.nombre} ${
        cliente.apellidos
      } _ ${cliente.celular}`;
    }
    this.getUsers();
    this.getMarcas();
    this.getEquipos();
    // this.getClientes()
  },
  mounted() {},
  methods: {
    getEquipos() {
      ServiceApi.get('/tarjetas/list')
        .then(response => {
          this.equipos = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    showModalCreateMarca() {
      const { value: marca } = Swal.fire({
        title: 'Digita el nombre de la marca',
        input: 'text',
        inputPlaceholder: 'Ingresa nombre de la marca',
        confirmButtonText: 'Guardar',
      }).then(response => {
        if (response.value) {
          this.loading = true;
          let data = {
            marca: response.value.toUpperCase(),
          };
          ServiceApi.post('/marca/create', data)
            .then(response => {
              this.marcas.push(response.data.data);
              this.marca = response.data.data.id;
              this.loading = false;
            })
            .catch(err => {
              this.$noty.error('Ocurrio un error al crear la marca');
              this.marca = 1;
              this.loading = false;
            });
        } else {
          this.marca = 1;
          this.$noty.warning('El nombre de la marca es requerido');
        }
      });
    },
    checkForm() {
      if (!this.cliente) {
        this.$noty.error('Debe asignar la orden a un cliente');
      } else if (!this.sintoma) {
        this.$noty.error('El síntoma es requerido');
      } else if (!this.marca) {
        this.$noty.error('La marca es requerida');
      } else if (!this.diagnostico) {
        this.$noty.error('El diagnóstico es requerido');
      } else if (!this.estado.estado) {
        this.$noty.error('El estado es requerido');
      } else if (!this.servicio) {
        this.$noty.error('El servicio es requerido');
      } else if (!this.accesorios) {
        this.$noty.error('El campo accesorios es requerido');
      }
      // else if(!this.precio){
      //     this.$noty.error('El precio es requerido')
      // }
      // else if(this.precio < 1){
      //     this.$noty.error('El precio debe ser mayor que cero "0"')
      // }
      else {
        this.saveInformation();
      }
    },
    reasignarEstado() {
      if (this.estado.estado != 'Pendiente') {
        this.estado.pendiente.autorizacion = false;
        this.estado.pendiente.repuesto = false;
        this.estado.pendiente.cotizacion = false;
      }
    },
    validarCheckboxEstado(value) {
      switch (value) {
        case 'autorizacion':
          if (this.estado.pendiente.autorizacion) {
            this.estado.pendiente.repuesto = false;
            this.estado.pendiente.cotizacion = false;
          }
          break;
        case 'repuesto':
          if (this.estado.pendiente.repuesto) {
            this.estado.pendiente.autorizacion = false;
            this.estado.pendiente.cotizacion = false;
          }
          break;
        case 'cotizacion':
          if (this.estado.pendiente.cotizacion) {
            this.estado.pendiente.repuesto = false;
            this.estado.pendiente.autorizacion = false;
          }
          break;
      }
    },
    async saveInformation() {
      this.disabledButton = true;
      this.loading = true;
      let cedula = this.cliente.split('_')[0];

      let data = {
        fecha: Moment().format('YYYY/MM/DD h:mm:ss'),
        clienteCedula: cedula.trim(),
        sintoma: this.sintoma,
        marcaId: this.marca,
        diagnostico: this.otroDiagnostico
          ? this.otroDiagnostico
          : this.diagnostico,
        estado: this.estado,
        servicio: this.servicio,
        accesorios: this.accesorios,
        precio: this.precio,
        observaciones: this.observaciones,
        tecnico:
          this.estado.estado === 'Urgente' ||
          this.servicio === 'revision_mostrador' ||
          this.servicio === 'Analisis'
            ? this.tecnico.split('-')[0]
            : null,
      };
      ServiceApi.post('/ordenes/create', data)
        .then(response => {
          if (response.data.status) {
            // console.log('REPUESTA CREAR:::', response.data);
            this.disabledButton = false;
            this.ordenId = response.data.data.id;
            this.generarImpresion(response.data.data.id);
            let alerta = response.data.data.alerta;
            let tecnicoAsignado = `${
              response.data.tecnicoAsignado.nombre
            } ${response.data.tecnicoAsignado.apellidos}`;
            try {
              this.$ws.$emitToServer(`ALERTS`, 'alert', { alerta });
            } catch (error) {
              console.log(
                'ERRRO EN LAS ALERTAS EN TIEMPO REAL:::::',
                error
              );
            }

            Swal.fire({
              type: 'success',
              title: `Orden de servicio # ${
                this.ordenId
              } Técnico: ${tecnicoAsignado}`,
              showConfirmButton: true,
              timer: 12000,
            });
            this.loading = false;
            this.$router.push('/ordenes');
          }
        })
        .catch(err => {
          console.log('EL ERROR:::', err);
          this.disabledButton = false;
          this.loading = false;
          this.$noty.error(
            'Ocurrio un error al crear la orden de servicio, intente nuevamente o contacte el administrador'
          );
        });
    },
    onCancel() {},
    getMarcas() {
      this.loading = true;
      ServiceApi.get('/marcas/list')
        .then(response => {
          //console.log('RESPUESTA:::', response)
          let data = response.data.data;
          this.marcas = data;
          this.marca = 100;
          if (!data.length)
            this.$noty.warning('No se encontraron marcas creadas');
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.$router.push('/ordenes');
        });
    },
    getClientes() {
      this.clientesList = [];
      this.loading = true;
      let data = {
        filter: this.cliente,
      };
      ServiceApi.post(`/cliente/listSinPaginacion`, data)
        .then(response => {
          // console.log('RESPUESTA:::', response)
          let data = response.data.data;
          this.clientes = data;
          this.loading = false;
          // this.setClienteList()
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.$router.push('/ordenes');
        });
    },
    setClienteList() {
      this.loading = true;
      this.clientes.map((item, key) => {
        this.clientesList.push(
          `${item.cedula} _ ${item.nombre} ${item.apellidos}`
        );
      });
      this.clientesList = this.clientesList.reverse();
      this.loading = false;
    },
    getUsers() {
      this.loading = true;
      ServiceApi.get('/user/list')
        .then(response => {
          //console.log('RESPUESTA:::', response)
          let data = response.data.data.filter(
            t => t.rol != 'ADMIN_MAIN'
          );
          this.tecnicos = data;
          this.tecnicosSelect = data.map((element, key) => {
            return (
              element.id +
              ' - ' +
              element.nombre +
              ' ' +
              element.apellidos
            );
          });

          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          // this.$noty.error('Ocurrio un error al consultar los usuarios')
          this.loading = false;
          this.$router.push('/ordenes');
        });
    },
    generarImpresion(ordenId) {
      let element = document.getElementById('impresion');
      let content = document.getElementById('orden_id');
      content.innerHTML = `Orden de servicio N° ${ordenId}`;
      var ventana = window.open('', 'PRINT', 'height=500,width=700');
      ventana.document.write(
        '<html><head><title>' + 'SOLUCASA' + '</title>'
      );
      ventana.document.write('</head><body >');
      ventana.document.write(element.innerHTML);
      ventana.document.write('</body></html>');
      ventana.document.close();
      ventana.focus();
      ventana.print();
      ventana.close();
      return true;
    },
    getFecha() {
      return Moment().format('YYYY/MM/DD h:mm:ss');
    },
  },
};
</script>
